module.exports = __webpack_public_path__ + "img/DiNapoli-4.6eccf83f.jpg";